import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { StandardShoeWidths } from "src/app/models/standard-shoe-widths.model";
import { ApiService } from "../api.service";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: 'root'
  })
  export class StandardShoeWWidthsService extends BaseService {

    constructor (
      protected apiService: ApiService,
      protected http: HttpClient
    ) {
      super(apiService, http, 'standard-shoe-widths');
    }


  getStandardShoeWidths() {
    return this.http.get<StandardShoeWidths[]>(`${this.apiUrl}`);
  }
}
